import PropTypes from 'prop-types';

export const V3ModelType = props =>
  PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    attributes: PropTypes.shape({
      created_at: PropTypes.string,
      modified_at: PropTypes.string,
      ...props,
    }),
  });

export const AffiliateType = V3ModelType({
  address_1: PropTypes.string,
  address_2: PropTypes.string,
  auto_canceled_enabled: PropTypes.bool,
  auto_canceled_time: PropTypes.string,
  auto_checkout_enabled: PropTypes.bool,
  auto_checkout_time: PropTypes.string,
  city: PropTypes.string,
  config: PropTypes.shape({}),
  country: PropTypes.string,
  email_importer_enabled: PropTypes.bool,
  fax: PropTypes.string,
  friendly_id: PropTypes.string,
  geofence_radius_m: PropTypes.number,
  is_live: PropTypes.bool,
  name: PropTypes.string,
  phone: PropTypes.string,
  postal_code: PropTypes.string,
  province: PropTypes.string,
  region: PropTypes.string,
  short_name: PropTypes.string,
  timezone: PropTypes.string,
  website: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/types/index.js